export default {
  line_items: [
    {
      lead_times : [6, 8, 10],
      pricing    : [
        [0, 0, 0],
        [0, 0, 0],
      ],
      quantities: [
        'Low Production (500-1000)',
        'High Production (>1000)',
      ],
      product_key: 'mx-pcb-assembly',
    },
  ],
};
